<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonTableStyles engineer-list">
            <van-loading
                class="pageLogin"
                v-if="loading"
                type="spinner"
                color="#1989fa"
            ></van-loading>
            <van-nav-bar
                title="工程信息"
                left-text=""
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        @load="onLoad"
                    >
                        <ul class="list" v-if="list.length > 0">
                            <template v-for="(item, index) in list">
                                <li :key="index">
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header">
                                            <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                            <span class="headerName">工程编号：{{ item.engineering_number }}</span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>工程名称：{{ item.engineering_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                                <span>工程位置：{{ item.engineering_location }}</span>
                                            </p>
                                            <div class="row-item">
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                    <span>工程类型：{{ item.engineering_type_name }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_gy_5.png" alt="">
                                                    <span>是否重点：{{ item.is_emphasis?'是':'否' }}</span>
                                                </p>
                                            </div>
                                            <p>
                                                <img src="@/assets/images/icons/icon_3.png" alt="">
                                                <span>关联客户：{{ item.rel_client_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                                <span>建设单位：{{ item.client_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_3.png" alt="">
                                                <span>建设规模：{{ item.construction_scale }}</span>
                                            </p>
                                            <div class="row-item">
                                                <p>
                                                    <img src="@/assets/images/icons/icon_21.png" alt="">
                                                    <span>预计方量：{{ item.projected_capacity }}</span>
                                                </p>
                                                <p>
                                                    <img src="@/assets/images/icons/icon_21.png" alt="">
                                                    <span>已用方量：{{ item.used_capacity }}</span>
                                                </p>
                                            </div>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                <span>登记时间：{{ item.register_time }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_4.png" alt="">
                                                <span>备注：{{ item.remarks }}</span>
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>
<script>

export default {
    // 关联工程信息列表
    name: 'engineer-list',
    data() {
        return {
            client_id: '',
            list: [],
            loading: false,
            finished: false,
            refreshing: false,
            pageindex: 0,
            pagesize: 6,
        };
    },
    created() {
        this.client_id = this.$route.query.client_id;
    },
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.back();
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.back();
        },
        // 下拉刷新
        onRefresh() {
            this.pageindex = 0;
            this.list = [];
            // 清空列表数据
            this.finished = false;
            // 重新加载数据
            this.loading = true;
            this.refreshing = false;
            this.onLoad();
        },
        // 上拉加载更多
        onLoad() {
            this.pageindex++;
            // 拉取客户列表数据
            this.getList();
        },

        // 拉取客户列表数据
        getList() {
            // 请求列表数据地址
            const getUrl = '/interfaceApi/sale/engineering_manager/get_engineering_info_by_clientid'
                + `?client_id=${this.client_id}&pageindex=${this.pageindex}&pageSize=${this.pagesize}`;
            this.$axios
                .get(getUrl)
                .then(res => {
                    const data = res.rows || [];
                    if (data.length < this.pagesize) {
                        this.finished = true;
                    }
                    this.list.push(...data);
                    this.loading = false;
                }).catch(error => {
                    this.finished = true;
                    this.loading = false;
                    this.$dialog({ message: error });
                });
        },
    },
};
</script>
<style lang="stylus" scoped>
.engineer-list
    height 100%
    section
        height calc(100% - 44rpx)
        background: #f0f0f0;
        .operate
            height 45rpx
            position relative
            button
                width 50%
                height 45rpx
                font-size 14rpx
                line-height 45rpx
                color #333333
                border none
                background #fff
            &:after
                content ''
                border-left 2px solid #F0F0F0
                height 15rpx
                position absolute
                left 50%
                top 15rpx
        .van-pull-refresh
            height 100%
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            .list
                background #F0F0F0
                padding 15rpx
                li
                    .state
                        position absolute
                        top 15rpx
                        right 15rpx
                        font-size 12rpx
                        color #D60110
                        font-weight 600
                    .row-item
                        display flex
                        justify-content space-between
                        p
                            width 50%;
                .btn-con
                    display flex
                    height 50rpx
                    border-top: 1px solid #f0f0f0;
                    .btn-item
                        flex 1
                        text-align center
                        margin-top 8rpx
                        .btn-span
                            width 70rpx
                            border 1px solid #5588F1
                            display inline-block
                            text-align center
                            color #5588F1
                            border-radius 3rpx
                            padding 6rpx 0
                            font-size 14rpx;
                    .btn-item01
                        position relative
                        &:before
                            content ' '
                            position absolute
                            right 0
                            width 1px
                            height 15rpx
                            background #D7D7D7
                            top 8rpx
        .contactInfo
            h5,p
                font-size 16rpx
                line-height 45rpx
                text-align center
            h5
                color #333333
                background #F8F8F8
            p
                color #0189FC
                border-bottom 1px solid  #F0F0F0

</style>
